<template>
    <div>
        <!-- Modal for navigation warning -->
        <b-modal
        id="leave-warning-modal"
        hide-header
        hide-footer
        no-close-on-esc
        no-close-on-backdrop
        centered
        >
        <div class="text-center leave-warning-text p-4">
            <i class="fas fa-exclamation-triangle text-danger" style="font-size: 3rem;"></i>
            
            <div class="alert-text mt-3 py-2">{{ $t("visit-information-form.warning_message") }}</div>

            <div class="mt-4 d-flex justify-content-center">
            <b-button variant="danger" class="mx-2" @click="confirmLeave">{{ $t("visit-information-form.yes") }}</b-button>
            <b-button variant="secondary" class="mx-2" @click="stayOnPage">{{ $t("visit-information-form.back") }}</b-button>
            </div>
        </div>
        </b-modal>
    </div>
</template>

<script>
    import t from 'typy';

    export default {
        name: "LeaveWarningModal",
        data() {
            return {

            }
        },
        methods: {
            confirmLeave() {
                this.$emit('confirm');
            },
            stayOnPage() {
                this.$emit('cancel');
            }
        }
    }
</script>


<style lang="scss" scoped>

    .leave-warning-text {
        font-size: 14px;
        font-family: "Poppins", sans-serif;
    }

</style>